import { render, staticRenderFns } from "./MenuListTableTwo.vue?vue&type=template&id=a8ad7230&scoped=true&"
import script from "./MenuListTableTwo.vue?vue&type=script&lang=js&"
export * from "./MenuListTableTwo.vue?vue&type=script&lang=js&"
import style0 from "./MenuListTableTwo.vue?vue&type=style&index=0&id=a8ad7230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ad7230",
  null
  
)

export default component.exports